import React from "react";
import { MdArrowForwardIos } from "react-icons/md";
import { Link } from "react-router-dom";

function LetterGenerate() {
  const optionsArr = [
    {
      title: "Generate Offer Letter",
      link: "/admin/letter/generate/table/letter/Offer%20Letter",
    },
    {
      title: "Generate Custom Letter with Salary Table",
      link: "/admin/letter/generate/table/letter/Custom%20Letter",
    },
    {
      title: "Generate Experience Letter",
      link: "/admin/letter/generate/all/text/letter/Experience%20Letter",
    },
    {
      title: "Generate Increment Letter",
      link: "/admin/letter/generate/all/text/letter/Increment%20Letter",
    },
    {
      title: "Generate Reliving Letter",
      link: "/admin/letter/generate/all/text/letter/Reliving%20Letter",
    },
    {
      title: "Generate Any Custom Text Letter",
      link: "/admin/letter/generate/all/text/letter/Custom%20Letter",
    },
  ];

  const moreOptionArr = [
    {
      title: "Add New Template",
      link: "/admin/letter/template/add",
    },
    {
      title: "All Templates",
      link: "/admin/letter/template/get/all",
    },
    {
      title: "Generated Letter History",
      link: "/admin/letter/history",
    },
  ];

  return (
    <div className="w-full flex justify-center items-center">
      <div className="w-[90vw] py-5">
        <h1 className="text-[30px] font-medium text-left w-full">
          Letter Generate
        </h1>
        <div className="w-full mt-5">
          <div className="rounded-[5px] border">
            {optionsArr.map((opt, i) => (
              <Link to={opt.link}>
                <section
                  className={`p-3 flex justify-between items-center hover:bg-slate-50 ${
                    i === optionsArr.length - 1 ? "" : "border-b-[1px]"
                  }`}
                >
                  <p className="text-slate-700 font-normal text-[17px]"> 
                    {opt.title}
                  </p>
                  <MdArrowForwardIos className="text-slate-500" />
                </section>
              </Link>
            ))}
          </div>
          <h3 className="text-slate-500/80 font-semibold text-[15px] my-5">MORE</h3>
          <div className="rounded-[5px] border">
            {moreOptionArr.map((opt, i) => (
              <Link to={opt.link}>
                <section
                  className={`p-3 flex justify-between items-center hover:bg-slate-50 ${
                    i === moreOptionArr.length - 1 ? "" : "border-b-[1px]"
                  }`}
                >
                  <p className="text-slate-700 font-normal text-[17px]">
                    {opt.title}
                  </p>
                  <MdArrowForwardIos className="text-slate-500" />
                </section>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LetterGenerate;
